module.exports = __webpack_public_path__ + "img/jiqi-0-1.2f017b5c.png";